class CustomCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.language = window.location.pathname.split('/')[1];
    this.cartDrawer = document.querySelector('.cart__drawer');
    this.body = document.body;
    this.init();
  }

  init() {
    const cartButton = document.querySelector('.site-header__cart');

    if (cartButton) {
      cartButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.openCartDrawer();
      });
    }

    const cartRemoveButtons = document.querySelectorAll('.cart__remove');

    cartRemoveButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.removeItem(button.getAttribute('href'));
      });
    });

    this.addQuantityListeners();

    const closeButton = this.querySelector('.cross');

    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeCartDrawer();
      });
    }

    const continueShopping = this.querySelector('.cdrawer-chekout-btn.cross');
    if (continueShopping) {
      continueShopping.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeCartDrawer();
      });
    }

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.updateCartDrawer.bind(this));
  }

  addQuantityListeners() {
    const cartPlusButtons = document.querySelectorAll('.plus');
    const cartMinusButtons = document.querySelectorAll('.minus');

    cartPlusButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.changeQuantity(button, 1);
      });
    });

    cartMinusButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.changeQuantity(button, -1);
      });
    });
  }

  changeQuantity(button, change) {
    const quantityInput = button.closest('form').querySelector('input[type="text"]');

    if (!quantityInput) return;

    const newQuantity = Math.max(1, parseInt(quantityInput.value || 0) + change);
    quantityInput.value = newQuantity;

    const formData = new FormData(button.closest('form'));

    this.updateQuantity(formData, newQuantity);
  }

  updateQuantity(formData, quantity) {
    formData.append('quantity', quantity);

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        this.updateCartDrawer();
      })
      .catch(error => console.error("Error updating quantity:", error));
  }


  openCartDrawer() {
    this.cartDrawer.classList.add('show-cart__drawer');
    this.body.classList.add('cv--show-cart__drawer');
  }

  closeCartDrawer() {
    this.cartDrawer.classList.remove('show-cart__drawer');
    this.body.classList.remove('cv--show-cart__drawer');
  }

  updateCartDrawer() {
    fetch(`${this.language === 'en' ? '/en' : ''}/cart`)
      .then(response => response.text())
      .then(html => {
        this.cartDrawer.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart__drawer').innerHTML;
      })
      .finally(() => {
        this.openCartDrawer();
        this.init();
      })
      .catch(error => console.error("Error updating cart drawer:", error));
  }

  removeItem(itemUrl) {
    fetch(itemUrl, { method: 'POST' })
      .then(response => response.text())
      .then(data => {
        this.updateCartDrawer();
      })
      .then(html => {
        this.cartDrawer.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart__drawer').innerHTML;
      });
  }

  getSectionsToRender() {
    return [...document.querySelectorAll('[data-section-id]')].map(section => section.id);
  }
}

customElements.define('custom-cart-drawer', CustomCartDrawer);